import { render, staticRenderFns } from "./SampleGrid.vue?vue&type=template&id=4c1bbd3e"
import script from "./SampleGrid.vue?vue&type=script&lang=js"
export * from "./SampleGrid.vue?vue&type=script&lang=js"
import style0 from "./SampleGrid.vue?vue&type=style&index=0&id=4c1bbd3e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1bbd3e')) {
      api.createRecord('4c1bbd3e', component.options)
    } else {
      api.reload('4c1bbd3e', component.options)
    }
    module.hot.accept("./SampleGrid.vue?vue&type=template&id=4c1bbd3e", function () {
      api.rerender('4c1bbd3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleGrid.vue"
export default component.exports